<div
  class="fixed inset-0 bg-black/50 z-[60] flex items-end"
  role="dialog"
  aria-modal="true"
  tabindex="0"
  (click)="onBackdropClick()"
  (keydown.escape)="onCloseClick()"
  (keydown.enter)="onBackdropClick()"
>
  <!-- eslint-disable-next-line @angular-eslint/template/click-events-have-key-events -->
  <div
    class="w-full bg-white rounded-t-2xl bottom-sheet-slide-up max-h-[80vh] flex flex-col"
    style="padding-bottom: env(safe-area-inset-bottom, 0px)"
    role="document"
    (click)="$event.stopPropagation()"
  >
    <div class="flex items-center justify-between px-4 py-3 bg-black rounded-t-2xl shrink-0">
      <div class="flex items-center gap-2">
        @if (showBackButton) {
          <button
            type="button"
            class="flex items-center justify-center size-8 bg-transparent border-none cursor-pointer"
            aria-label="Go back"
            (click)="onBackClick()"
          >
            <ld-svg-icon [src]="chevronLeftIcon" class="size-5 [--stroke-0:white]" aria-hidden="true" />
          </button>
        }
        <span class="font-dm text-base font-semibold text-white">{{ displayTitle }}</span>
      </div>
      <button
        type="button"
        class="flex items-center justify-center size-8 bg-transparent border-none cursor-pointer"
        aria-label="Close"
        (click)="onCloseClick()"
      >
        <ld-svg-icon [src]="closeIcon" class="size-6 [--stroke-0:white]" aria-hidden="true" />
      </button>
    </div>

    <div class="overflow-y-auto flex-1">
      @for (item of displayItems; track item.id) {
        @if (item.divider) {
          <div [id]="item.id" role="separator" class="border-t border-ld-border my-1"></div>
        } @else if (item.header) {
          <div
            [id]="item.id"
            class="px-4 pt-3 pb-1 font-dm text-xs font-semibold uppercase tracking-wide text-ld-neutral-500"
          >
            {{ item.label }}
          </div>
        } @else {
          <button
            type="button"
            [id]="item.id"
            class="w-full flex items-center gap-3 px-4 py-3.5 bg-transparent border-none text-left"
            [class.cursor-pointer]="!item.disabled"
            [class.cursor-not-allowed]="item.disabled"
            [class.opacity-50]="item.disabled"
            [class.hover:bg-ld-neutral-50]="!item.disabled"
            [class.active:bg-ld-neutral-100]="!item.disabled"
            [class.text-ld-error]="item.danger && !item.disabled"
            [class.text-ld-neutral-700]="!item.danger && !item.disabled"
            [class.text-ld-neutral-400]="item.disabled"
            [disabled]="item.disabled"
            (click)="onItemClick(item)"
          >
            @if (item.icon) {
              <ld-svg-icon
                [src]="item.icon"
                class="size-5 shrink-0 [--fill-0:currentColor] [--stroke-0:currentColor]"
                [class.text-ld-bottom-sheet-icon]="!item.disabled && !item.danger"
                [class.text-ld-bottom-sheet-icon-disabled]="item.disabled"
                [class.text-ld-error]="!item.disabled && item.danger"
                aria-hidden="true"
              />
            }
            <span class="font-dm text-sm font-medium leading-5 flex-1">{{ item.label }}</span>
            @if (item.hasChildren) {
              <ld-svg-icon
                [src]="chevronRightIcon"
                class="size-5"
                style="--stroke-0: var(--color-ld-neutral-500)"
                aria-hidden="true"
              />
            }
          </button>
        }
      }
    </div>
  </div>
</div>
